import { useQuery } from '@tanstack/react-query';
import { pick } from 'lodash';

import { Groups } from '@app/client';

import { useGroupFilterParams } from './useGroupFilterParams';
import { useGroupId } from './useGroupId';
import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query to call `/groups/:groupId`.
 */

type UseGetGroupOptions = {
    isAuthenticated?: boolean;
};

export const useGetGroup = ({ isAuthenticated = true }: UseGetGroupOptions = {}) => {
    const groupId = useGroupId();
    // TODO: If `spam` is all we care about, then we should simply
    // check `searchParams` for the presence of `spam=true`.
    const filters = useGroupFilterParams();
    const groupFilters = pick(filters, ['spam']);

    const cache = groupsCacheKeys.group(groupId, groupFilters);

    return useQuery(
        cache,
        ({ signal }) =>
            Groups.callGetGroup({ groupId, query: { ...groupFilters }, settings: { signal } }, isAuthenticated),
        {
            enabled: Boolean(groupId),
            keepPreviousData: true,
            retry: false,
        },
    );
};
